import React from "react";
import styled from "styled-components";
import { BsCheckLg } from "react-icons/bs";
import { FiPhoneCall } from "react-icons/fi";
import { Link } from "react-router-dom";

const Plans = () => {
  return (
    <PlansMain>
      <PlansContainer>
        <h2>
          Make the wise decision for <br /> your business
        </h2>
        <p>Choose from our affordable 3 packages</p>
      </PlansContainer>
      <PlansStart>
        <PlansGrid>
          <PlansCard>
            <h3>Free</h3>
            <p>15 day trail to explore & learn about the application</p>
            <div className="feature">
              <div>
                <div className="checkBox">
                  <BsCheckLg className="icon" />
                </div>
                15 day trail
              </div>
              <div>
                <div className="checkBox">
                  <BsCheckLg className="icon" />
                </div>
                24/7 Chat support
              </div>
            </div>
            <Link className="btnFree">Start Free Trail</Link>
          </PlansCard>
          <PlansCard>
            <h3>Business</h3>
            <p>Get full access to the application with most affordable plan</p>
            <h2>
              <p>from</p>
              <span>₹</span>1500<span>/mo</span>
            </h2>
            <div className="feature">
              <div>
                <div className="checkBox">
                  <BsCheckLg className="icon" />
                </div>
                Unlimited access
              </div>
              <div>
                <div className="checkBox">
                  <BsCheckLg className="icon" />
                </div>
                24/7 continuous service
              </div>
              <div>
                <div className="checkBox">
                  <BsCheckLg className="icon" />
                </div>
                Expert & experienced <br /> marketing team support
              </div>
            </div>
            <Link className="btnPaid">Get Started</Link>
          </PlansCard>
          <PlansCard>
            <h3>Enterprise</h3>
            <p>For large organizations who have custom business requirements</p>
            <div className="call">
              <p>
                <FiPhoneCall className="callIcon" /> Call On
              </p>
              <h3>+91 8888830536</h3>
            </div>
            <Link className="btnFree">Contact Sales</Link>
          </PlansCard>
        </PlansGrid>
      </PlansStart>
    </PlansMain>
  );
};

export default Plans;

const PlansMain = styled.div`
  padding: 4rem calc((100vw - 1200px) / 2);
  padding-bottom: 6rem;

  @media only screen and (max-width: 991px) {
    padding-bottom: 0rem;
  }
`;

const PlansContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h2 {
    font-size: 45px;
    font-weight: 600;
    color: #20204f;
    text-align: center;
    line-height: 55px;
  }
  p {
    font-size: 16px;
    font-weight: 500;
    color: #535353;
    margin-top: 20px;
  }
  @media only screen and (max-width: 991px) {
    h2 {
      font-size: 35px;
      font-weight: 600;
      color: #20204f;
      text-align: center;
      line-height: 40px;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      color: #535353;
      margin-top: 20px;
    }
  }
`;

const PlansStart = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PlansGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2.5rem;
  margin-top: 4.5rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    margin: 3rem 0.7rem;
    grid-gap: 1.3rem;
  }
`;

const PlansCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  text-align: center;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  padding: 10px;
  border-radius: 7px;

  .btnFree {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    border: 2px solid #20204f;
    text-decoration: none;
    color: #20204f;
    padding: 10px 15px;
    width: 80%;
    border-radius: 7px;
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
  }
  .btnPaid {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    border: 2px solid #20204f;
    text-decoration: none;
    color: #20204f;
    padding: 6px 20px;
    width: 80%;
    border-radius: 7px;
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
  }
  &:nth-child(1) {
    color: #20204f;
    background-color: #aee4fd;
    border: 3px solid #20204f;
    width: 340px;

    @media only screen and (max-width: 991px) {
      height: 350px;
      width: 100%;
    }
  }
  &:nth-child(2) {
    margin: auto;
    color: #20204f;
    /* background-color: #9be2aa; */
    background-color: #a9f8ba;
    transform: scale(1.2);
    width: 320px;
    height: 450px;
    border: 3px solid #3aaa35;

    h3 {
      font-size: 25px;
      font-weight: 500;
    }
    p {
      font-weight: 500;
      margin-top: 7px;
    }
    h2 {
      margin-top: 15px;
      p {
        font-size: 13px;
        font-weight: 500;
      }
      span {
        font-size: 17px;
        font-weight: 500;
      }
      @media only screen and (max-width: 991px) {
        font-size: 30px;
        p {
          font-size: 15px;
          font-weight: 500;
        }
        span {
          font-size: 23px;
          font-weight: 500;
        }
      }
    }
    .feature {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      margin-top: 20px;
      div {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        text-align: left;
        margin-bottom: 10px;
        font-size: 16px;

        .checkBox {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 23px;
          width: 23px;
          border-radius: 50%;
          margin-right: 7px;
          border: 1.5px solid #3aaa35;
        }
        .icon {
          margin-top: 0px;
          margin-right: 5px;
          margin-left: 5px;
          font-size: 18px;
        }
      }
    }
    @media only screen and (max-width: 991px) {
      transform: scale(1);
      width: 100%;
      height: 450px;
      .feature {
        div {
          font-size: 18px;
        }
      }
    }
  }
  &:nth-child(3) {
    color: #20204f;
    background-color: #fcf1f7;
    border: 3px solid #20204f;
    width: 340px;

    @media only screen and (max-width: 991px) {
      height: 350px;
      width: 100%;
      margin-bottom: 1.3rem;
    }
  }
  &:nth-child(1),
  &:nth-child(3) {
    h3 {
      font-size: 26px;
      font-weight: 500;
    }
    p {
      font-weight: 500;
      margin-top: 7px;
    }
    h2 {
      margin-top: 15px;
      p {
        font-size: 15px;
        font-weight: 500;
      }
      span {
        font-size: 19px;
        font-weight: 500;
      }
    }
    .feature {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      margin-top: 20px;
      div {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        text-align: left;
        margin-bottom: 10px;
        font-size: 18px;

        .checkBox {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 24px;
          width: 24px;
          border-radius: 50%;
          margin-right: 7px;
          border: 1.5px solid #20204f;
        }
        .icon {
          margin-top: 0px;
          margin-right: 5px;
          margin-left: 5px;
          font-size: 18px;
        }
      }
    }
    .call {
      margin-top: 50px;
      .callIcon {
        font-size: 45px;
        margin-right: 10px;
      }
      p {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 23px;
        text-align: center;
      }
      h3 {
        font-weight: 500;
        margin-top: 10px;
        font-size: 28px;
      }
    }
    @media only screen and (max-width: 991px) {
      .call {
        margin-top: 25px;
        .callIcon {
          font-size: 35px;
          margin-right: 10px;
        }
        p {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 23px;
          text-align: center;
        }
        h3 {
          font-weight: 500;
          margin-top: 10px;
          font-size: 28px;
        }
      }
    }
  }
`;
